import { render, staticRenderFns } from "./PieECharts.vue?vue&type=template&id=2279bdbb"
import script from "./PieECharts.vue?vue&type=script&lang=js"
export * from "./PieECharts.vue?vue&type=script&lang=js"
import style0 from "./PieECharts.vue?vue&type=style&index=0&id=2279bdbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports